import { assetApiClient } from '@/clients/AssetAPIClient';
import { IImageAsset } from '@/data/models/album';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './ImagePreviewModal.scss';
import PrsImage from '@/components/common/PrsImage/PrsImage';
import { SignedUrl } from '@/data/models/signedUrl';

type ModalProps = {
  show: boolean;
  onClose: () => void;
  asset: IImageAsset | null | undefined;
  albumId: string | undefined;
};

export default function ImagePreviewModal({
  show,
  onClose,
  asset,
  albumId,
}: ModalProps) {
  const [signedUrl, setSignedUrl] = useState<SignedUrl>();
  const { t } = useTranslation();

  useEffect(() => {
    if (asset?.id && albumId) {
      assetApiClient.getAssetDownloadUrl(asset.id, albumId).then((result) => {
        setSignedUrl({ url: result.signedUrl, mimeType: result.mimeType });
      });
    } else {
      setSignedUrl(undefined);
    }
  }, [asset]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      className="image-preview-modal"
    >
      <Modal.Body onClick={onClose}>
        {signedUrl?.url ? (
          <PrsImage
            signedUrl={signedUrl}
            alt={t('product.coverArt')}
          ></PrsImage>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
